import { Edit, Eye, Trash } from "tabler-icons-react";

export const FAQHeaders = [
  { id: "id", numeric: true, disablePadding: true, label: "ID" },
  {
    id: "faqCatName",
    numeric: false,
    disablePadding: true,
    label: "FAQ Category",
  },
  {
    id: "faqCode",
    numeric: false,
    disablePadding: true,
    label: "Code",
  },

  {
    id: "faqCatNote",
    numeric: false,
    disablePadding: true,
    label: "Description",
  },
  // {
  //   id: "state",
  //   numeric: false,
  //   disablePadding: true,
  //   label: "Status",
  // },

  {
    id: "actions",
    view: <Eye />,
    edit: <Edit />,
    delete: <Trash />,
    numeric: false,
    label: "Actions",
  },
];
